module.exports = __webpack_public_path__ + "img/UC-LearnAndUnderstandAngularJS.90647d0e.jpg";